export function encodeBase64(data: string) {
    return btoa(data);
};
export function decodeBase64(data: string) {
    return atob(data);
};